import React from 'react';
import { PapiGallection, PapiUser } from '@wix/da-types-papi';
import { getCommentsBlockAnchor } from '../../helpers';
import CommentThread, {
  CommentableTypes,
} from '@wix/da-shared-react/pkg/CommentThread';
import { GallectionType } from '../../../../../../types/gallection';
import { SCRAPS_FOLDER_ID, ALL_FOLDER_ID } from '@wix/da-url';

import s from './FolderCommentThread.scss';

export interface Props {
  folder: PapiGallection;
  featuredFolder: PapiGallection;
  currentUser: PapiUser;
}

export const FolderCommentThread: React.FC<Props> = ({
  folder,
  featuredFolder,
  currentUser,
}) => {
  if (!folder) {
    return null;
  }
  return (
    <div
      id={getCommentsBlockAnchor(folder.folderId)}
      className={s['comments-wrapper']}
    >
      <div className={s['comments']}>
        <CommentThread
          className={s['comment-thread']}
          currentUser={currentUser}
          commentableTypeId={
            folder.type === GallectionType.COLLECTION
              ? CommentableTypes.COMMENT_COLLECTION
              : CommentableTypes.COMMENT_GALLERY
          }
          commentableItemId={
            [ALL_FOLDER_ID, SCRAPS_FOLDER_ID].includes(folder.folderId)
              ? featuredFolder.folderId
              : folder.folderId
          }
          statsAndControls="order"
          postbox="top"
        />
      </div>
    </div>
  );
};
FolderCommentThread.displayName = 'FolderCommentThread';

export default FolderCommentThread;
